import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/estiloGlobal.css'
import vuetify from './plugins/vuetify'
import traductor from './plugins/traductor'

Vue.config.productionTip = false

Vue.use (traductor);

Vue.prototype.$global = new Vue({
  data() {
    return {
      URLParams: '61067',
      ruta: process.env.VUE_APP_URL_LOGO_PARKING,
    
    }
  },

  methods: {

    errorCargandoLogotipo (e) {
      console.log('error cargando logotipo');
     // e.target.src = this.$global.ruta + '/61067.png';
      e.target.src = require('@/assets/logo.png');
    }, // fin metodo errorCargandoLogotipo
    
  }
});

Vue.directive('inputfilter', {
  inserted: function(el, binding, vnode) {
    if (binding.value !== undefined) {
      el.addEventListener('input', async function(e) {
        let start = e.target.selectionStart;
        let valor = e.target.value;
        if (binding.value.expresionRegular !== undefined && binding.value.expresionRegular.length == 2)
          valor = valor.replace(new RegExp(binding.value.expresionRegular[0], binding.value.expresionRegular[1]), '');
        if (binding.value.mayusculas)
          valor = valor.toUpperCase();
        if (binding.value.minusculas)
          valor = valor.toLowerCase();
        if (valor.length == e.target.value.length-1)  {
          start--;
        } else if (binding.value.longitudMaxima) {
          while (valor.length > binding.value.longitudMaxima) {
            if (start > 0) start--;
            valor = valor.slice (0,start) + valor.slice(start+1);
          }
        }
        await vnode.componentInstance.$emit('input', valor);
        e.target.setSelectionRange(start, start);
      });
      el.addEventListener('change', async function(e) {
        let valor = e.target.value;
        if (binding.value.limpiarPorLaIzquierda)
          valor = valor.trimStart();
        if (binding.value.limpiarPorLaDerecha)
          valor = valor.trimEnd();
        if (valor != e.target.value)
          await vnode.componentInstance.$emit('input', valor);
      });
    }
  }
})

store.dispatch ('ESTABLECER_ESTADO_INICIAL')

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
